module.exports = __webpack_public_path__ + "img/wechat2.9c75756c.png";